module.exports = __webpack_public_path__ + "static/office_small_green-70980767b8db8663090cda5335d0bc67.jpg";